import { useQuery } from "@tanstack/react-query";
import React, { FC } from "react";
import { Navigate, Outlet } from "react-router-dom";

import { getSessionToken } from "../../api/token-helper.ts";
import useUserStore from "../../stores/user.store.ts";
import { api } from "../../api/custom-api.ts";

type Props = {
  children: React.ReactNode;
};

const PublicRoute: FC<Props> = ({ children }) => {
  const accessToken = getSessionToken();

  const { setUser, user } = useUserStore((state) => state);

  useQuery({
    queryKey: ["whoAmI"],
    queryFn: () => {
      return api.auth.getAuthWhoAmI();
    },
    onSuccess: (response) => {
      setUser(response);
    },
    enabled: !!accessToken,
  });

  if (user) {
    return <Navigate to={"/warehouses"} />;
  }
  return (
    <>
      <Outlet />
      {children}
    </>
  );
};

export default PublicRoute;
